<template>
  <div class="row-content">
    <div class="row-title">
      <span>球场产权 / 性质</span>
    </div>
    <div class="data-wrapper">
      <div class="echart-class-status" id="echart-pie"></div>
      <div class="echart-class-status" id="echart-pie-quality"></div>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  import {debounce} from "@/assets/js/utils";
  import storage from "@/utils/storage";

  export default {
    props:{
      statisticsSquadLevel:[],
      statisticsQuality:[],
      schoolComplete:{},
      propsReloadTime:{
        type:Number,
        required:false,
        default:30000
      }
    },

    data(){
      return {
        loading:false,
        mapObj:null,
        mapObjQuality:null,
        pieDatakey:0,
        youthList:[], // 精英机构列表
        squadList:[], // 精英机构球队列表
        qualityList:[], // 精英机构球队列表
        completeList:[], // 精英机构球队列表
        isComplete:0,
        selectYouthIndex:0, // 精英机构球队统计默认精英机构选择
        youthAutoChangeTimer:null, // 精英机构默认切换
        changeTimer:null,
        userRole:storage.get("userInfo").userRole,
      };
    },

    computed:{
      echartsPieOptions(){
        let option = {
          tooltip:{
            trigger:"item",
          },
          legend:{
            orient: 'vertical',
            bottom:10,

            textStyle:{
              color:"#61A8FF",
            },
          },
          series:[
            {
              name:"",
              type:"pie",
              radius:"55%",
              bottom:"30%",
              center:["50%", "50%"],
              data:[], // 数据
              label:{
                formatter:"{c}",
                position:"top",
                show:true,
              },
              emphasis:{
                itemStyle:{
                  shadowBlur:10,
                  shadowOffsetX:0,
                  shadowColor:"rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        return option;
      },
    },
    watch:{
      // 监测协会列表显示内容
//      'selectYouthIndex':function(){
//        this.drawClassStatus();
//      }
    },

    mounted(){
      this.loadData(); // 加载数据
      this.autoChangeSelectYouthIndex(); // 自动变动
      this.drawClassStatus(); // 绘制饼状图
      this.drawQualityStatus(); // 绘制饼状图

      if(this.mapObj){
        window.onresize = debounce(
          function(){
            this.mapObj.resize();
          },
          100,
          false
        );
      }
      if(this.mapObjQuality){
        window.onresize = debounce(
          function(){
            this.mapObjQuality.resize();
          },
          100,
          false
        );
      }
    },

    destroyed(){
      clearInterval(this.youthAutoChangeTimer);
    },

    methods:{
      loadData(){
//        let youthData = Object.keys(this.statisticsSquadLevel); // 获取数组
//
//        // 机构下拉框赋值
//        let youthList = [];
//        youthData.forEach((item, i) => {
//          youthList.push({
//            label:item,
//            value:i
//          })
//        });
//        this.youthList = youthList;
//
//        // 遍历球队数组
//        let squadData = [];
//        let completeData = [];
//        for(let key in this.statisticsSquadLevel){
//          squadData.push(this.statisticsSquadLevel[key]);
//          if(this.schoolComplete[key]){
//            completeData.push(1);
//          }else{
//            completeData.push(0);
//          }
//        }
        this.squadList = this.statisticsSquadLevel;
        this.qualityList = this.statisticsQuality;
      },

      // 手动切换培训班
      youthChange(){
        if(this.youthAutoChangeTimer) clearInterval(this.youthAutoChangeTimer);
        if(this.changeTimer) clearTimeout(this.changeTimer);

        this.changeTimer = setTimeout(() => {
          this.autoChangeSelectYouthIndex()
        })
      },

      // 切换显示当前精英机构数据 selectYouthIndex   youthAutoChangeTimer
      autoChangeSelectYouthIndex(){
        if(this.youthAutoChangeTimer) clearInterval(this.youthAutoChangeTimer);
        this.youthAutoChangeTimer = setInterval(() => {
          this.selectYouthIndex = this.selectYouthIndex + 1;
        }, 4000)
      },

      // 绘制会员协会培训班统计表
      drawClassStatus(){
        // 设置图例
        const {series} = this.echartsPieOptions;
        const sourceSeries = series[0];
        sourceSeries.data = this.formateSquadDataPieData(); // 获取data数据
        let color = [
          '#68D8FE', '#FAC858', '#EE6666'
        ];
        const options = Object.assign({}, this.echartsPieOptions, {
          series:[sourceSeries],
          color
        });

        // 开始画图
        const mapDom = document.getElementById("echart-pie");
        let class_status = echarts.init(mapDom);
        class_status.setOption(options);
        this.mapObj = class_status;
      },
      drawQualityStatus(){
        // 设置图例
        const {series} = this.echartsPieOptions;
        const sourceSeries = series[0];
        sourceSeries.data = this.formateQualityDataPieData(); // 获取data数据
        let color = [
          '#24b4e4', '#dcfa77', '#ee79a1'
        ];
        const options = Object.assign({}, this.echartsPieOptions, {
          series:[sourceSeries],
          color
        });

        // 开始画图
        const mapDom = document.getElementById("echart-pie-quality");
        let class_status = echarts.init(mapDom);
        class_status.setOption(options);
        this.mapObjQuality = class_status;
      },

      // 球队数据转化pie饼图数据
      formateSquadDataPieData(){
//        const selectYouthIndex = this.selectYouthIndex;
//        if(selectYouthIndex >= this.youthList.length){
//          this.selectYouthIndex = 0;
//        }
        // 获取球队列表中的一个
        return this.squadList;
      },
      // 球队数据转化pie饼图数据
      formateQualityDataPieData(){
//        const selectYouthIndex = this.selectYouthIndex;
//        if(selectYouthIndex >= this.youthList.length){
//          this.selectYouthIndex = 0;
//        }
        // 获取球队列表中的一个
        return this.qualityList;
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .row-content
    padding 1.25rem 0

    .row-title
      color #68D8FE
      font-weight 600
      font-size 16px
      margin-bottom 0.4rem
      display flex
      align-items center

    .data-wrapper
      display flex
      flex-wrap wrap
      position: relative;
      .echart-class-status
        height 260px
        width 50%
      .child
        position: absolute; /* 设置为 absolute 进行绝对定位 */
        color: #ffbd57;
        bottom: 15px;
        right: 50px;
</style>
